import useWindowsSize from "@/Hooks/useWindowsSize";
import Skeleton from "react-loading-skeleton";

type Props = {
  totales: number;
};

export const DefaultPlp = ({ totales }: Props): JSX.Element => {
  const rows = [];

  for (let i = 0; i < totales; i++) {
    rows.push(<DesingView key={i} />);
  }

  return <>{rows}</>;
};

export const DesingView = (): JSX.Element => {
  const { width } = useWindowsSize();
  const SkeletonViewDesing = () => (
    <div className="ps-product shadow mb-3 text-center">
      <div className="ps-product__thumbnail develop__vendero__border__bottom">
        <Skeleton
          className={
            width >= 1200
              ? "card-img-top--skeleton"
              : "card-img-top--skeleton-V2"
          }
        />
      </div>
      <div className="ps-product__container">
        <div className="ps-product__content">
          <div className="develop___product-title text-center text-truncate">
            <Skeleton className="develop_Title_Skeleton_V2" />
          </div>
          <div className="d-flext flex-column text-center">
            <div className="w-100 text-center">
              <div className="sales">
                <span className="mr-0 cart-price price-plp price-not-found price-pdp">
                  <span className="develop___Color_SalePrice__red">
                    {width >= 1200 ? (
                      <Skeleton
                        height={75}
                        className="develop_saolePrice_skeleton"
                      />
                    ) : (
                      <Skeleton className="develop_saolePrice_skeleton_V2" />
                    )}
                  </span>
                </span>
              </div>
            </div>
            <div className="p-0 w-100 align-items-center"></div>
          </div>
          <div className="d-flex mt-2">
            <div className={width <= 360 ? "" : "p-1 w-100"}>
              <Skeleton className="btn__develop--skeleton develop__buttons--skeleton" />
              {width >= 1200 ? <br /> : ""}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-6">
      {SkeletonViewDesing()}
    </div>
  );
};
